/* eslint-disable @typescript-eslint/indent */
import { runtimeConfig } from '@app/common/config'
import { GREENHOUSE_PROXY_URL } from '@app/constants'

import { Departments } from './types'

if (!runtimeConfig.GREENHOUSE_ID) {
  throw new Error('GREENHOUSE_ID not provided')
}

export const GREENHOUSE_HOST = 'https://boards-api.greenhouse.io/'

export async function getGreenhouseJobs(): Promise<Departments> {
  const response = await fetch(GREENHOUSE_PROXY_URL)
  const data: Departments = await response.json()
  return { departments: data.departments.filter(department => department.jobs?.length) }
}
